module.exports = __webpack_public_path__ + "media/images/app/visitors/couture/how-it-works/step2-c09b4aaf21cdc057d3d88f026f0776fa.svg";